import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlidesTallAdd"><Path d="M19.5 5.5H7.5V21.5H19.5V5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 10.5V13.5M13.5 13.5V16.5M13.5 13.5H10.5M13.5 13.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 5.5V2.5H4.5V18.5H7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlidesTallAdd;
